<!-- ts -->
<template>
  <template v-if="props.dropdown">
    <el-dropdown v-if="list.length > 0" trigger="hover" placement="bottom-end">
      <span class="action-dropdown-trigger" aria-label="操作菜单">
        <span class="el-dropdown-link">
          {{ $t('assets.operation') }}
          <el-icon class="el-icon--right">
            <arrow-down />
          </el-icon>
        </span>
      </span>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item v-for="item in list" :key="item.name"
            :class="item.type === 'delete' ? 'table-action-item-danger' : 'table-action-item'"
            @click="formAction(item, props.rowInfo)">
            <span class="table-action-item-content">
              <component :is="resolveIcon(item)" class="table-action-item-icon" />
              <span>{{ typeof item.nameFunc === "function" ? item.nameFunc(props.rowInfo) : $t(item.name) }}</span>
            </span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </template>

  <template v-else-if="list.length > 0">
    <el-button v-for="item in list" :key="item.name" link
      :type="item.type == 'delete' ? 'danger' : 'primary'" class="action-btn" @click="formAction(item, props.rowInfo)"
      :icon="item.icon">{{
        typeof item.nameFunc === "function"
          ? item.nameFunc(props.rowInfo)
          : $t(item.name)
      }}</el-button>
  </template>
</template>
<script lang="ts">
import { defineComponent, computed, PropType } from "vue";
import { useI18n } from "vue-i18n";
import { checkPermi } from "@/utils/permission";
import {
  Operation,
  View,
  Edit,
  Delete,
  Check,
  Search,
  Document
} from "@element-plus/icons-vue";

const iconMap: Record<string, any> = {
  view: View,
  look: View,
  edit: Edit,
  modify: Edit,
  delete: Delete,
  remove: Delete,
  check: Check,
  deal: Document,
  handle: Document,
  detail: Document,
  info: Document,
  search: Search,
};

export default defineComponent({
  name: "table-action",
  components: { Operation },
  props: {
    rowInfo: {
      type: Object,
      required: true
    },
    actionList: {
      type: Array as PropType<Array<any> | undefined>,
      required: true
    },
    dropdown: {
      type: Boolean,
      default: false
    }
  },
  emits: ["formAction"],
  setup(props) {
    const { t } = useI18n();
    const list: any = computed(() => {
      return (props?.actionList || []).filter((item: any) => {
        if (!checkPermi(item.hasPermi)) {
          return false;
        }
        // show类型改为返回boolean的函数,或变量
        if (item.show === undefined) {
          return item;
        }
        const isShowFunction = typeof item.show === "function";
        const isShowTrueOrUndefined =
          item.show === true || item.show === undefined;
        return isShowFunction
          ? item.show(props.rowInfo)
          : isShowTrueOrUndefined;
      });
    });
    const resolveIcon = (item: any) => {
      const key = String(item?.icon || item?.type || item?.name || "").toLowerCase();
      return iconMap[key] || (item?.type === "delete" ? Delete : Operation);
    };
    return {
      props,
      list,
      t,
      resolveIcon
    };
  },
  methods: {
    formAction(item: any, rowInfo: Record<string, any>): void {
      this.$emit("formAction", item, rowInfo);
    }
  }
});
</script>

<style scoped>
.action-dropdown-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  color: var(--el-color-primary);
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.action-dropdown-trigger:hover {
  background-color: var(--el-fill-color-light);
}

.table-action-item-content {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.table-action-item-icon {
  width: 14px;
  height: 14px;
}

.table-action-item-danger {
  color: var(--el-color-danger);
}
</style>
